// extracted by mini-css-extract-plugin
export default {"products-page":"ProductsPage_products-page__qIHWw"};